module.exports = __webpack_public_path__ + "static/media/rppr1.58957811.png";